import React, {useEffect, useState} from 'react';
import {Button, Grid, Space, Typography} from 'antd';
import {Link} from 'react-router-dom';
import {useTheme} from '../ThemeProvider';

const {Text} = Typography;
const {useBreakpoint} = Grid;

const COOKIE_CONSENT_KEY = 'cookie_consent';

const CookieConsent: React.FC = () => {
    const [visible, setVisible] = useState(false);
    const {isDark} = useTheme();
    const screens = useBreakpoint();

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1100,
                background: isDark ? '#1f1f1f' : '#ffffff',
                borderTop: isDark ? '1px solid #434343' : '1px solid #d9d9d9',
                boxShadow: isDark
                    ? '0 -4px 16px rgba(0,0,0,0.5)'
                    : '0 -4px 16px rgba(0,0,0,0.1)',
                padding: screens.md ? '20px 32px' : '16px',
            }}
        >
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                display: 'flex',
                flexDirection: screens.md ? 'row' : 'column',
                alignItems: screens.md ? 'center' : 'stretch',
                gap: '16px',
            }}>
                <div style={{flex: 1}}>
                    <Text style={{fontSize: '14px'}}>
                        We use cookies to enhance your experience and analyze site traffic.
                        Please choose whether to accept or decline cookies.{' '}
                        <Link to="/privacy-policy" style={{textDecoration: 'underline'}}>
                            Learn more
                        </Link>
                    </Text>
                </div>
                <Space size="small" style={{flexShrink: 0}}>
                    <Button onClick={handleDecline}>
                        Decline
                    </Button>
                    <Button type="primary" onClick={handleAccept}>
                        Accept
                    </Button>
                </Space>
            </div>
        </div>
    );
};

export default CookieConsent;
